import {
  ApiInsuranceCardItemResponse,
  ApiPatientInsuranceResponse,
  ApiRelationshipToInsuredResponse,
  InsuranceStatus,
  InsuranceType,
  InsuranceTypeDesc,
} from 'src/app/core/models';

export const primaryInsurance = {
  insuranceId: 1,
  insuranceName: 'Blue Cross Blue Shield',
  nameOfInsured: 'Tracie Riveria',
  relationshipToInsured: 'Self',
  insuranceNo: '1234578629',
  insuranceGroupNo: 'ABC1234',
  reportGroup: 'MCR',
};

export const secondaryInsurance = {
  insuranceId: 2,
  insuranceName: 'UnitedHealth Group',
  nameOfInsured: 'Tracie Riveria',
  relationshipToInsured: 'Spouse',
  insuranceNo: '927384823762',
  insuranceGroupNo: 'XYZ8765',
  reportGroup: 'MR',
};

export const getRelationshipsToInsured = (): ApiRelationshipToInsuredResponse[] => {
  return [
    {
      lookupCode: '1',
      lookupDescription: 'Self',
    },
    {
      lookupCode: '2',
      lookupDescription: 'Spouse',
    },
    {
      lookupCode: '3',
      lookupDescription: 'Dependent',
    },
  ];
};

export const getPatientInsurance = (): ApiPatientInsuranceResponse[] => {
  return [
    {
      patientInsuranceData: [
        { ...primaryInsurance, insuranceType: InsuranceType.Primary },
        { ...secondaryInsurance, insuranceType: InsuranceType.Secondary },
      ],
    },
  ];
};

export const getPatientInsuranceCards = (): ApiInsuranceCardItemResponse[] => {
  return [
    {
      patientInsuranceId: primaryInsurance.insuranceId,
      insuranceCompanyName: primaryInsurance.insuranceName,
      nameOfInsured: primaryInsurance.nameOfInsured,
      insuranceNumber: primaryInsurance.insuranceNo,
      groupNumber: primaryInsurance.insuranceGroupNo,
      activeDesc: InsuranceStatus.Active,
      insuranceTypeDesc: InsuranceTypeDesc.Primary,
    },
    {
      patientInsuranceId: secondaryInsurance.insuranceId,
      insuranceCompanyName: secondaryInsurance.insuranceName,
      nameOfInsured: secondaryInsurance.nameOfInsured,
      insuranceNumber: secondaryInsurance.insuranceNo,
      groupNumber: secondaryInsurance.insuranceGroupNo,
      activeDesc: InsuranceStatus.Pending,
      insuranceTypeDesc: InsuranceTypeDesc.Secondary,
    },
  ];
};

export const createPatientInsurance = () => {};
